import Banner from '../../sections/common/banner';
import { data } from '../../../globals/data/notes';
import SectionEstimation3 from '../../sections/home/index3/section-estimation3';
import Intro from '../../sections/common/intro';
import SectionWhyChooseUs3 from '../../sections/home/index3/section-why-choose-us3';
import ServicesPageHelmet from '../../helmets/ServicesPageHelmet';

export default function NotesPage() {
  return (
    <>
      <ServicesPageHelmet />

      <Banner _data={data.banner} />
      <Intro _data={data.intro} />
      <SectionEstimation3 _data={data.estimation} />
      <SectionWhyChooseUs3 _data={data.whychoosus} />
    </>
  );
}
